import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import format from 'date-fns/format';

import CalendarIcon from '../../../../components/icons/CalendarIcon';

const propTypes = {
  eventDate: PropTypes.string.isRequired,
  overCoverPhoto: PropTypes.bool,
};

const FutureEventNullState = ({ eventDate, overCoverPhoto }) => {
  const formattedDate = format(
    new Date(eventDate),
    'MMM d, yyyy',
  ).toUpperCase();

  const classes = classNames('future-event-null-state', {
    'future-event-null-state--over-photo': overCoverPhoto,
  });

  return (
    <div className={classes}>
      <span className="future-event-null-state-date">
        <CalendarIcon size={16} />
        {formattedDate}
      </span>
      <p className="future-event-null-state-title">
        Gallery opens on event day
      </p>
      <p className="future-event-null-state-subtitle">
        Photos will appear here after the event
      </p>
    </div>
  );
};

FutureEventNullState.propTypes = propTypes;

export default FutureEventNullState;
